








































































import Vue from 'vue'
import ClientCard from './Remittance/ClientCard.vue'
import { createRemittance } from '@/api/Remittances/remittances.api'
import { getCardInfo } from '@/utils/functions'

export default Vue.extend({
  components: {
    appClientCard: ClientCard,
  },
  props: {
    data: Object,
  },
  data() {
    return {
      remittance: this.$store.getters['remittance/remittance'],
    }
  },
  methods: {
    async onNext() {
      try {
        await createRemittance(this.data)
        await this.$router.push({ name: 'remittances-list' })
        return false
      } catch (error) {
        return false
      }
    },
    getCardInfo,
  },
})
